import { useQuery } from '@tanstack/react-query';

import { listOrganizations } from 'api/adminOrganizations';
import { queryKeys } from 'constants/queryKeys';
import { organizationManagementStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import type { TOrganization } from 'types';
import { toErrorMessage } from './utils';

type UseAdminOrganizationsResult = {
  organizations: TOrganization[];
  loading: boolean;
  error: string | undefined;
};

export function useAdminOrganizations(): UseAdminOrganizationsResult {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: [queryKeys.ORGANIZATIONS, user?.uid],
    enabled: Boolean(user?.uid),
    queryFn: listOrganizations,
    retry: false,
  });

  return {
    organizations: query.data ?? [],
    loading: Boolean(user?.uid) && query.isPending,
    error: query.error
      ? toErrorMessage(
          query.error,
          organizationManagementStrings.errors.loadOrganizationsFailed,
        )
      : undefined,
  };
}
